
import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./FDScheme.css";

const API_BASE = "https://narrowitsolution.in/api";

const FixedDepositScheme = () => {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    serviceType: "FD",
    serviceName: "",
    minDepositAmount: "",
    minDepositTenure: "",
    additionalBonus: "",
    depositLockinPeriod: "",
    interestLockinPeriod: "",
    preClosureRoi: "",
    closureChargeBeforeLockinValue: "",
    closureChargeBeforeLockinType: "",
    closureChargeAfterLockinValue: "",
    closureChargeAfterLockinType: "",
    loanRoiType: "",
    loanRoi: "",
    loanApprovalOnDeposit: "",
    roi: "",
    roiFrequency: "",
    interestCompounding: "",
    prefix: "",
    schemeStatus: "Active",
    isFixedTenure: "",
    maxTenure: "",
    superAdminId: "",
  });

  // ✅ Show Toast When Message Updates
  useEffect(() => {
    if (message) {
      if (message.startsWith("✅")) {
        toast.success(message, { position: "top-center", autoClose: 2500, theme: "colored" });
      } else if (message.startsWith("⚠️")) {
        toast.warning(message, { position: "top-center", autoClose: 3000, theme: "colored" });
      } else if (message.startsWith("❌")) {
        toast.error(message, { position: "top-center", autoClose: 3000, theme: "colored" });
      } else {
        toast.info(message, { position: "top-center", autoClose: 2500, theme: "colored" });
      }
    }
  }, [message]);

  // ✅ Handle Input Change
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // ✅ Fetch All FD/MIS Schemes
  const fetchSchemes = async () => {
    const adminId = localStorage.getItem("adminuserId");
    try {
      const res = await axios.get(`${API_BASE}/get-all-fdmis?superAdminId=${adminId}`);
      if (res.data.success) setSchemes(res.data.data || []);
    } catch (err) {
      console.error("Error fetching FD/MIS schemes:", err);
    }
  };

  useEffect(() => {
    const adminId = localStorage.getItem("adminuserId");
    if (adminId) {
      setFormData((prev) => ({ ...prev, superAdminId: adminId }));
    }
    fetchSchemes();
  }, []);

  // // ✅ Handle Submit (Create / Update)
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setMessage("");

  //   try {
  //     const cleanedData = {
  //       ...formData,
  //       minDepositAmount: Number(formData.minDepositAmount) || 0,
  //       minDepositTenure: Number(formData.minDepositTenure) || 0,
  //       additionalBonus: Number(formData.additionalBonus) || 0,
  //       depositLockinPeriod: Number(formData.depositLockinPeriod) || 0,
  //       interestLockinPeriod: Number(formData.interestLockinPeriod) || 0,
  //       preClosureRoi: Number(formData.preClosureRoi) || 0,
  //       closureChargeBeforeLockinValue: Number(formData.closureChargeBeforeLockinValue) || 0,
  //       closureChargeAfterLockinValue: Number(formData.closureChargeAfterLockinValue) || 0,
  //       loanRoi: Number(formData.loanRoi) || 0,
  //       loanApprovalOnDeposit: Number(formData.loanApprovalOnDeposit) || 0,
  //       roi: Number(formData.roi) || 0,
  //       maxTenure: Number(formData.maxTenure) || 0,
  //     };

  //     const url = editingId
  //       ? `${API_BASE}/update-fdmis/${editingId}`
  //       : `${API_BASE}/create-fdmis`;

  //     const method = editingId ? axios.put : axios.post;
  //     const response = await method(url, cleanedData);

  //     if (response.data.success) {
  //       setMessage(
  //         editingId
  //           ? "✅ FD/MIS Scheme Updated Successfully!"
  //           : "✅ FD/MIS Scheme Created Successfully!"
  //       );
  //       fetchSchemes();
  //       resetForm();
  //     } else {
  //       setMessage("⚠️ Failed to save FD/MIS scheme.");
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     setMessage("❌ Error saving scheme. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // ✅ Handle Submit (Create / Update)
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage("");

  const adminId = localStorage.getItem("adminuserId");

  if (!adminId) {
    toast.error("Admin ID missing. Please log in again.");
    setLoading(false);
    return;
  }

  try {
    const cleanedData = {
      ...formData,
      superAdminId: adminId, // ✅ Ensure it's always included
      minDepositAmount: Number(formData.minDepositAmount) || 0,
      minDepositTenure: Number(formData.minDepositTenure) || 0,
      additionalBonus: Number(formData.additionalBonus) || 0,
      depositLockinPeriod: Number(formData.depositLockinPeriod) || 0,
      interestLockinPeriod: Number(formData.interestLockinPeriod) || 0,
      preClosureRoi: Number(formData.preClosureRoi) || 0,
      closureChargeBeforeLockinValue: Number(formData.closureChargeBeforeLockinValue) || 0,
      closureChargeAfterLockinValue: Number(formData.closureChargeAfterLockinValue) || 0,
      loanRoi: Number(formData.loanRoi) || 0,
      loanApprovalOnDeposit: Number(formData.loanApprovalOnDeposit) || 0,
      roi: Number(formData.roi) || 0,
      maxTenure: Number(formData.maxTenure) || 0,
      isFixedTenure: 0,

    };

    const url = editingId
      ? `${API_BASE}/update-fdmis/${editingId}`
      : `${API_BASE}/create-fdmis`;

    const method = editingId ? axios.put : axios.post;
    const response = await method(url, cleanedData);

    if (response.data.success) {
      setMessage(
        editingId
          ? "✅ FD/MIS Scheme Updated Successfully!"
          : "✅ FD/MIS Scheme Created Successfully!"
      );
      fetchSchemes();
      resetForm();
    } else {
      setMessage("⚠️ Failed to save FD/MIS scheme.");
    }
  } catch (error) {
    console.error("API Error:", error);
    setMessage("❌ Error saving scheme. Please try again later.");
  } finally {
    setLoading(false);
  }
};


  // ✅ Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this scheme?")) return;
    try {
      const response = await axios.delete(`${API_BASE}/delete-fdmis/${id}`);
      if (response.data.success) {
        setMessage("🗑️ Scheme deleted successfully!");
        fetchSchemes();
      } else {
        setMessage("⚠️ Failed to delete scheme.");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setMessage("❌ Error deleting scheme. Please try again later.");
    }
  };

  // ✅ Handle Edit
  const handleEdit = (scheme) => {
    const adminId = localStorage.getItem("adminuserId") || "";
    setEditingId(scheme.id);
    setFormData({
      serviceType: scheme.serviceType || "FD",
      serviceName: scheme.serviceName || "",
      minDepositAmount: scheme.minDepositAmount || "",
      minDepositTenure: scheme.minDepositTenure || "",
      additionalBonus: scheme.additionalBonus || "",
      depositLockinPeriod: scheme.depositLockinPeriod || "",
      interestLockinPeriod: scheme.interestLockinPeriod || "",
      preClosureRoi: scheme.preClosureRoi || "",
      closureChargeBeforeLockinValue: scheme.closureChargeBeforeLockinValue || "",
      closureChargeBeforeLockinType: scheme.closureChargeBeforeLockinType || "",
      closureChargeAfterLockinValue: scheme.closureChargeAfterLockinValue || "",
      closureChargeAfterLockinType: scheme.closureChargeAfterLockinType || "",
      loanRoiType: scheme.loanRoiType || "",
      loanRoi: scheme.loanRoi || "",
      loanApprovalOnDeposit: scheme.loanApprovalOnDeposit || "",
      roi: scheme.roi || "",
      roiFrequency: scheme.roiFrequency || "",
      interestCompounding: scheme.interestCompounding || "",
      prefix: scheme.prefix || "",
      schemeStatus: scheme.schemeStatus || "Active",
      maxTenure: scheme.maxTenure || "",
      superAdminId: adminId,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Reset Form
  const resetForm = () => {
    setFormData({
      serviceType: "FD",
      serviceName: "",
      minDepositAmount: "",
      minDepositTenure: "",
      additionalBonus: "",
      depositLockinPeriod: "",
      interestLockinPeriod: "",
      preClosureRoi: "",
      closureChargeBeforeLockinValue: "",
      closureChargeBeforeLockinType: "",
      closureChargeAfterLockinValue: "",
      closureChargeAfterLockinType: "",
      loanRoiType: "",
      loanRoi: "",
      loanApprovalOnDeposit: "",
      roi: "",
      roiFrequency: "",
      interestCompounding: "",
      prefix: "",
      schemeStatus: "Active",
      isFixedTenure: "",
      maxTenure: "",
      superAdminId: "",
    });
    setEditingId(null);
  };

  // ✅ Input Renderer
  const renderInput = (label, name, type = "text", placeholder = "", options = null) => (
    <div className="fdmisform-group">
      <label>{label}</label>
      {options ? (
        <select
          name={name}
          value={formData[name]}
          onChange={handleChange}
          className="fdmis-select"
        >
          <option value="">Select</option>
          {options.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={formData[name]}
          onChange={handleChange}
          placeholder={placeholder}
          className="fdmis-input"
        />
      )}
    </div>
  );

  return (
    <div className="fdmis-scheme-container">
      <h2 className="fdmis-title">Fixed Deposit / MIS Scheme</h2>
      {/* <p className="fdmis-subtitle">Create, update, or manage FD/MIS schemes.</p> */}

      {/* ✅ FORM SECTION */}
      <form className="fdmis-scheme-form" onSubmit={handleSubmit}>
        <div className="fdmisform-row">
          {renderInput("Service Type", "serviceType", "text", "", ["FD", "MIS"])}
          {renderInput("Service Name", "serviceName", "text", "Enter Service Name")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Minimum Deposit Amount", "minDepositAmount", "number")}
          {renderInput("Minimum Tenure (Months)", "minDepositTenure", "number")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Additional Bonus (%)", "additionalBonus", "number")}
          {renderInput("Deposit Lock-in Period (Months)", "depositLockinPeriod", "number")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Interest Lock-in Period", "interestLockinPeriod", "number")}
          {renderInput("Pre-Closure ROI (%)", "preClosureRoi", "number")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Charge Before Lock-in", "closureChargeBeforeLockinValue", "number")}
          {renderInput("Type (Before)", "closureChargeBeforeLockinType", "text", "", ["Fixed", "Percentage"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Charge After Lock-in", "closureChargeAfterLockinValue", "number")}
          {renderInput("Type (After)", "closureChargeAfterLockinType", "text", "", ["Fixed", "Percentage"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Loan ROI Type", "loanRoiType", "text", "", ["Reducing", "Flat"])}
          {renderInput("Loan ROI (%)", "loanRoi", "number")}
        </div>

        <div className="fdmisform-row">
          {renderInput("Loan Approval (%)", "loanApprovalOnDeposit", "number")}
          {renderInput("ROI (%)", "roi", "number")}
        </div>

        <div className="fdmisform-row">
          {renderInput("ROI Frequency", "roiFrequency", "text", "", ["Monthly", "Quarterly", "Yearly"])}
          {renderInput("Interest Compounding", "interestCompounding", "text", "", ["Monthly", "Quarterly", "Yearly"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Prefix", "prefix", "text")}
          {renderInput("Scheme Status", "schemeStatus", "text", "", ["Active", "Inactive"])}
        </div>

        <div className="fdmisform-row">
          {renderInput("Max Duration (Months)", "maxTenure", "number")}
        </div>

        <div className="fdmis-btn-group">
          <button type="submit" className="fdmissubmit-btn" disabled={loading}>
            {loading ? "Processing..." : editingId ? "Update Scheme" : "Create Scheme"}
          </button>
          {editingId && (
            <button type="button" className="fdmiscancel-btn" onClick={resetForm}>
              Cancel Edit
            </button>
          )}
        </div>
      </form>

      {/* ✅ TABLE SECTION */}
      <div className="fdmisscheme-report">
        <div className="fdmisscheme-report-header">
          <h3>FD/MIS Scheme List</h3>
        </div>

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Name</th>
              <th>ROI</th>
              <th>Prefix</th>
              <th>Min Deposit</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {schemes.length > 0 ? (
              schemes.map((s, i) => (
                <tr key={s.id || i}>
                  <td>{i + 1}</td>
                  <td>{s.serviceType}</td>
                  <td>{s.serviceName}</td>
                  <td>{s.roi}%</td>
                  <td>{s.prefix}</td>
                  <td>{s.minDepositAmount}</td>
                  <td>{s.schemeStatus}</td>
                  <td className="btn-grp-fdscheme">
                    <button className="btn-edit" onClick={() => handleEdit(s)}>✏️</button>
                    <button className="btn-delete" onClick={() => handleDelete(s.id)}>🗑️ </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No schemes found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Toast Notification */}
      <ToastContainer />
    </div>
  );
};

export default FixedDepositScheme;
